import request from "@/utils/request";

/**
 * 用户积分信息
 * @param {*} params
 * @returns
 */
export function userIntegralApi() {
  return request({
    url: "/front/integral/user",
    method: "GET",
  });
}

/**
 * 用户积分记录
 * @param {*} params
 * @returns
 */
export function userIntegralListApi(params: {
  page?: number;
  limit?: number;
  offset?: number;
  pointsChange?: number | null;
}) {
  return request({
    url: "/front/integral/list",
    method: "GET",
    params,
  });
}

/**
 * 积分转账
 * @param {*} params
 * @returns
 */
export function userIntegralTransferApi(params: { amount: number }) {
  return request({
    url: "/front/integral/transfer",
    method: "GET",
    params,
  });
}
